
import { FC } from 'react';
import { Link } from 'react-router-dom';

export type ActionNotificationProps = {
    linkTo: string;
    onNext: () => void;
    isError: boolean;
    title: string | null;
    description: string | null;
    iconUrl: string | null;
    showButton: boolean;
    buttonText: string | null;
}



const ActionNotification: FC<Partial<ActionNotificationProps>> = ({ buttonText, showButton, linkTo, onNext, isError, title, description, iconUrl }) => {

    const imageUrl = iconUrl ? iconUrl : isError ? "/assets/images/failure_pict.svg" : "assets/images/success_pict.svg";


    return (<>

        <div className="content_sec white wf-section" style={{ height: '100vh' }}>
            <div className="signup_top_info">
                <div className="signup_pict">
                    <img src={imageUrl} loading="lazy" alt="" />
                </div>
                <h2 className="signup_title welcome">{title}</h2>
                <div>{description}</div>
                {
                    showButton ? <a href="#" className="button_full welcome w-button" onClick={onNext} >
                        {buttonText}
                    </a>
                        : null
                }

            </div>
        </div>

    </>);
}

export default ActionNotification;
